import React, {useState, useEffect} from "react";
import styles from './ViewPDF.module.css'
import {
  Document,
  Image,
  Page,
  StyleSheet,
  Text,
  View,
  Font,
  PDFDownloadLink,
  BlobProvider,
  usePDF,
  pdf
} from "@react-pdf/renderer";
import Button from "../Button/Button";
import fontSantander from '../../fonts/SantanderHeadline-Regular.ttf';
import fontSantanderBold from '../../fonts/SantanderHeadline-Bold.ttf';
import EmojiFest from '../../assets/emoji-fest.png'
import TopImage from '../../assets/elementosdiploma/top.png';
import BottomImage from '../../assets/elementosdiploma/bottom.png';
import SantanderLogo from '../../assets/elementosdiploma/santander.png';
import AcademiaLogo from '../../assets/elementosdiploma/academia.png';
import FinancieroLogo from '../../assets/elementosdiploma/financiero.png';


import appImage from '../../assets/appImage.png'
import { storage } from "../../firebase";
import { ref, uploadBytes } from 'firebase/storage'
import { v4 } from 'uuid'

import {
    FacebookShareButton,
    LinkedinShareButton,
    TwitterShareButton,
    WhatsappShareButton,
  } from "react-share";
import { BsFacebook, BsWhatsapp, BsInstagram, BsTwitter } from "react-icons/bs";

const TestPDF = ( {name, date} ) => {

    // EXECUTIVE: [521.86, 756.0]
    // LETTER: [612.0, 792.0]

    Font.register({ family: 'santander', src: fontSantander });
    Font.register({ family: 'santander-bold', src: fontSantanderBold });

    const capitalize = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    const localStyles = StyleSheet.create({
        page: {
            flexDirection: 'column',
            fontFamily: 'santander',
            backgroundColor: 'white'
        },
        sectionDate: {
            textAlign: 'center',
            fontFamily: 'santander-bold',
            fontSize: '14px',
            marginTop: 10,
            color: '#660099'
        },
        emojiContent: {
            textAlign:'center',
            marginTop: 40
        },
        emoji: {
            width: '40px',
            height: '40px',
        },
        section1: {
          textAlign: 'center',
          marginTop: 20,
        },
        title: {
            fontFamily: 'santander-bold',
            fontSize: '20px',
            color: '#660099'
        },
        text: {
            fontFamily: 'santander',
            fontSize: '16px',
            color: 'black',
            opacity: '0.5',
            marginTop: 10,
            marginHorizontal: 'auto',
            width: '60%',
        },
        logosContent: {
            flexDirection: 'row',
            justifyContent: 'space-between',
            width: '70%',
            margin: '50px auto',
            paddingRight: 30,
            paddingTop: 20
        },
        logoSantander: {
            height: '15px',
        },
        logoFinanciero: {
            height: '40px',
            paddingRight: 20,
            marginTop: -20
        },
        logoAcademia: {
            height: '30px',
            marginTop: -8
        },
        footer: {
            position: 'absolute',
            bottom: 0,
            width: '100vw',
        },
    });

    const pdfRender = (
        <Document>
            <Page size={'EXECUTIVE'} orientation="landscape" style={localStyles.page}>
                <View>
                    <Image src={TopImage}/>
                </View>
                <View style={localStyles.sectionDate}>
                    <Text>{date}</Text>
                </View>
                <View style={localStyles.emojiContent}>
                    <Text>
                        <Image src={EmojiFest} style={localStyles.emoji}/>
                    </Text>
                </View>
                <View style={localStyles.section1}>
                    <Text style={localStyles.title}>¡Felicitaciones {capitalize(name)}!</Text>
                    <Text style={localStyles.text}>Celebramos que te hayas capacitado en Educación Financiera junto a Santander Argentina.</Text>
                </View>
                <View style={localStyles.logosContent}>
                    <Image src={SantanderLogo} style={localStyles.logoSantander}/>
                    <Image src={FinancieroLogo} style={localStyles.logoFinanciero}/>
                    <Image src={AcademiaLogo} style={localStyles.logoAcademia}/>
                </View>
               
                <View style={localStyles.footer}>
                    <Image src={BottomImage} style={localStyles.bottomImage}/>
                </View>
            </Page>
        </Document>
    );

    const [urlToShare, setUrlToShare] = useState()

    const loadPDF = () => {
        // update({pdf})
        // console.log(instance.url)
    }

    // const [instance, updateInstance] = usePDF({ pdf });

    const [url, setUrl] = useState()

    // console.log(pdf)

    const uploadPdf = async () => {

        // const storeRef = ref(storage, `${v4()}`)

        // const blob = await pdf(pdfRender).toBlob();
        // console.log(blob)

        // let myPdf = <BlobProvider document={pdfRender}/>

        // console.log(myPdf)

        // uploadBytes(storeRef, myPdf).then(() => {
        //     alert('pdf upload??')
        // })
    }

    return (
        <div>
            {/* <h1 className={styles.share_title} onClick={uploadPdf}>test</h1> */}

            <h1 className={styles.share_title}>¡Compartelo en tus redes!</h1>
            <div className={styles.share_social}>
                <TwitterShareButton 
                    url={`www.santander.com.ar/educacion-financiera`}
                    title="Desafía tus conociminetos."
                >
                    <BsTwitter style={{ opacity: '.9'}} size={30} fill='white'/>
                </TwitterShareButton>
                <WhatsappShareButton 
                    url={`www.santander.com.ar/educacion-financiera`}
                    title="Desafía tus conociminetos."
                >
                    <BsWhatsapp style={{ opacity: '.9'}} size={30} fill='white'/>
                </WhatsappShareButton>
                <FacebookShareButton 
                    url={`www.santander.com.ar/educacion-financiera`}
                    title={"Desafía tus conociminetos."}
                >
                    <BsFacebook style={{ opacity: '.9'}} size={30} fill='white' />
                </FacebookShareButton>
            </div>
            <PDFDownloadLink
                document={pdfRender}
                fileName={"DesafiaTusConocimientos.pdf"}
                className={styles.download_button}
            >
                {({ loading }) =>
                    loading ? <Button text='Loading..'/> : <Button text='Descarga tu diploma'/>
                }
            </PDFDownloadLink>
        </div>
      );
}

export default TestPDF;

